import React from 'react'
import dataComunidad from "../dataComunidad";
import { useState } from "react";
import PropTypes from "prop-types";
import ModalComunidadClub from '../../components/modals/ModalComunidadClub';
import MicroModal from 'micromodal';

/**
 * Este componente renderiza la cuarta sección del club MakeMake que corresponde a la información sobre la comunidad lectora. Este componente hace uso del archivo
 * dataComunidad, el cual es mapeado para renderizar la información de la comunidad y recibe como props los textos de la interfaz. 
 * Se hace uso del componente ModalClubComunidad para visualizar la información completa de la comunidad.
 */

const ComunidadLectora = (props) => {

  const [idComunidad, setIdComunidad] = useState();
  const [objectComunidad, setObjectComunidad] = useState();
  const { traducciones } = props;

  const modalComunidad = (id, object) => {
    MicroModal.show('modal-club-comunidad', {
      awaitCloseAnimation: true,
    })
    setIdComunidad(id)
    setObjectComunidad(object)

  }

  return (
    <div className="seccion-morado-claro pt-5">
      <div className=" container">
        <div className=" col-lg-10 mx-auto">
          <div className=" row mx-0 justify-content-center">
            <div className='col-12 px-0 px-sm-4 col-sm-9'>
              <div className="d-xl-flex align-items-center justify-content-start pb-5">
                <span className='numero-titles-violeta titulo-violeta-act d-flex justify-content-center align-items-center mx-auto mx-xl-0'>3</span>
                <h2 className="titulos-actualizacion-club titulo-violeta-act mx-0 mx-xl-3 text-center text-xl-left ">{traducciones?.titulo || 'Comunidad lectora'}</h2>
              </div>
            </div>
            {/*Primera seccion*/}
            <div className=" col-lg-9 px-0 pb-5 onbackground-third--color">
              <p className='px-2 parrafo-acompanamiento'>
                {traducciones?.descripcion || 'En MakeMake nos interesa escuchar a nuestros lectores y lectoras. Te presentamos al grupo de promotores, profesores, lectores empedernidos y expertos a quienes apoyamos. Sigue sus canales y conéctate a un nuevo mundo de lecturas.'}
              </p>
            </div>
          </div>
          <div className=' row pb-5'>
            <p className=' titulo-planes titulo-violeta-act ml-3 text-center'>{traducciones?.conoce || 'Conoce nuestra comunidad'}</p>
            <div className='col-lg-4 col-xl-5 col-md-3 d-none d-md-block linea-violeta-club pt-md-4 mx-2 align-self-center'></div>
          </div>
          <div className="d-flex flex-wrap justify-content-start">
            {
              dataComunidad.map((comunidad, i) => {
                return (
                  <div key={`comunidad-${i}`} className="col-sm-9 col-lg-6 mx-auto mx-lg-0 pb-5 px-0">
                    <div className=' d-sm-flex mb-4'>
                      <div className="px-0 pb-2 pb-md-0 d-flex justify-content-center align-items-center">
                        <div className={`comunidad-act ${comunidad.clase}`}>{comunidad.clase}</div>
                      </div>
                      <div className="pt-md-3 mx-4 mx-lg-3 mx-xl-3 justify-content-center">
                        <p className='texto-comunidad text-center text-sm-left pb-2'>{comunidad.nombre}</p>
                        <div className="d-flex pb-2 align-items-center justify-content-center justify-content-sm-start">
                          <img src="/img/club-makemake/icon-user-instagram.png" alt="icono instagram"
                            className="img-icon-user2 mr-1" />
                          <a href={comunidad.link} className="user-comunidad2 focusable-secondary"
                            target="_black">{comunidad.arroba}</a>
                        </div>
                        <button id={`comunidad-${i}`}
                          className="d-flex justify-content-center justify-content-sm-start align-items-center"
                          onClick={() => {
                            modalComunidad(`comunidad-${i}`, comunidad)
                          }}
                        >
                          <span className='conoce-mas onbackground-third--color focusable-secondary'>{traducciones?.conoce_mas || 'Conoce más'}</span>
                          <div
                            id={`comunidad-${i}`}
                            className='boton-abre-tool ml-2 d-flex justify-content-center align-items-center '
                          >
                            <i className='icono-fa fas fa-plus fa-2x fa-fw '></i>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
      <ModalComunidadClub id={idComunidad} object={objectComunidad} texto={traducciones?.comunidad}/>
    </div>

  )
}

export default ComunidadLectora;

ComunidadLectora.propTypes={
  /**
   * Es un objeto que trae los textos de la interfaz, especificamente los de mi cuenta. Estos cambian dependiendo del idioma activo.
   */
  traducciones: PropTypes.object.isRequired
}

